import { Component, Input, OnInit } from '@angular/core';
import { NbDialogRef, NbDialogService } from '@nebular/theme';
import Swal, { SweetAlertIcon } from 'sweetalert2';
import { EmployeeService } from '../../../../employee.service';
import { NewEmployeeComponent } from '../../../../new-employee/new-employee.component';
import { FirebaseStorageService } from '../../../../services/firebase-storage.service';
import * as moment from 'moment';
import { finalize } from 'rxjs/operators';
import { v4 as uuidv4 } from 'uuid';
import { SasisopaService } from '../../../../services/sasisopa.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'ngx-document-detail-sasisopa-edit-create-delete',
  templateUrl: './edit-create-delete.component.html',
  styleUrls: ['./edit-create-delete.component.scss']
})
export class EditCreateDeleteComponent implements OnInit {
  loading = false;
  downloadURLs = [];
  files: any = [];
  employees = [];
  @Input() action = 'create'
  @Input() stationId: string;
  @Input() documentId: number;
  @Input() item = { id: 0, name: '', code: '', date: new Date(), id_responsable: '', type: '' }

  constructor(
    protected ref: NbDialogRef<EditCreateDeleteComponent>,
    private firebaseStorageService: FirebaseStorageService,
    private employeeService: EmployeeService,
    private dialogService: NbDialogService,
    public route: ActivatedRoute,
    private sasisopaService: SasisopaService
  ) { }

  ngOnInit() {
    this.getEmployees()
  }

  async loadImage(event: any) {
    if (!event.target.files.length) return;
    this.loading = true;
    for await (const image of event.target.files) {
      const reader = new FileReader();
      await reader.readAsDataURL(image);
      this.files.push(image);
      this.loading = false;
    }
  }

  async getEmployees () {
    const [err, result] = await this.employeeService.getEmployees(this.stationId);
    if (err) return this.alert('Oops, intenta más tarde [Error. Lista empleados]', 'error');
    this.employees = result.data;
  }

  async store() {
    this.loading = true;
    const date = moment(this.item.date).format('YYYY-MM-DD')
    const [error, response] = await this.sasisopaService.storeDocumentDetail(this.stationId, this.documentId, { ...this.item, date })
    if (error) {
      this.loading = false;
      return this.alert('Error', 'error', 'Oops... ocurrio algo, intenta mas tarde');
    }
    if (!this.files.length) {
      this.loading = false;
      this.ref.close(true);
      return this.alert('Éxito', 'success', 'Se creo el detalle');
    }
    await this.firebaseStorageService.setPath(`images/sasisopa/${this.stationId}/procedimiento${this.route.snapshot.params.procedureId}`);
    this.downloadURLs = [];
    for await (const file of this.files){
      const filename = uuidv4();
      const fileRef = await this.firebaseStorageService.referenceCloudStorage(filename);
      const task = this.firebaseStorageService.taskCloudStorage(filename, file);
      // get notified when the download URL is available
      task.snapshotChanges().pipe(
        finalize(() => {
          fileRef.getDownloadURL().subscribe(async (url) => {
            this.downloadURLs = this.downloadURLs.concat([url]);
            if (this.files.length === this.downloadURLs.length) {
              const [err] = await this.sasisopaService.uploadImage(this.stationId, { type: 'detail', type_id: response.data.id, urls: this.downloadURLs });
              if (err) return this.alert('Oops, ocurrio un error al cargar el archivo', 'error');
              this.loading = false;
              this.ref.close(true);
              this.alert('Éxito', 'success', 'Se creo el detalle');
            }
          });
        }),
      ).subscribe();
    }
  }

  async update() {
    this.loading = true;
    const date = moment(this.item.date).format('YYYY-MM-DD')
    const [error] = await this.sasisopaService.updateDetail(this.item.id, { ...this.item, date })
    this.loading = false;
    if (error) return this.alert('Error', 'error', 'Oops... ocurrio algo, intenta mas tarde');
    this.ref.close(true);
    return this.alert('Éxito', 'success', 'Se édito el detalle');
  }

  openNewEmployee() {
    this.dialogService.open(NewEmployeeComponent, {
      hasScroll: true,
      context: {
        stationId: this.stationId,
      },
    }).onClose.subscribe(employeeStored => employeeStored ? this.getEmployees() : null);
  }

  async delete(index: number) { this.files.splice(index, 1); }

  close() { this.ref.close(); }

  alert(title: string = 'asdasd', type: SweetAlertIcon = 'success', text: string = '') {
    return Swal.fire({
      icon: type,
      title: title,
      text: text,
    });
  }

}
